var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"newHeader"},[_c('HeaderBrand',{attrs:{"brand":_vm.brand,"to":_vm.firstRoute}}),(_vm.screenWidth)?_c('Navbar',{ref:"navbar",attrs:{"menus":_vm.menus,"desktop":_vm.screenWidth,"showName":true}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }